import PageTitle from 'components/text/PageTitle';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Page: FunctionComponent<Props> = props => {
    const { children, className = '', testId = TEST_ID, title } = props;

    return (
        <div className={`${className} ${styles.page}`} data-testid={testId}>
            {title ? <PageTitle text={title} /> : null}

            {children}
        </div>
    );
};

export default Page;
